import { Request } from '~src/httpClient/serverApi/requests/Request';
import { ILoginParams } from '~src/sessionManagement/serverApi/types/ILoginParams';
import { ISessionInfo } from '~src/sessionManagement/serverApi/types/ISessionInfo';

export class LoginRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('login', params);
  }
}
